export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-blue-900 via-blue-800 to-blue-900 text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <img
                src="./thinkpacklogo.png"
                alt="Thinkpack Technologies"
                className="h-15 w-20 object-contain"
              />
            </div>
            <p className="text-sm text-blue-200 leading-relaxed mb-6">
              Empowering Nigeria with innovative technology solutions, reliable connectivity, and digital transformation services.
            </p>
            <div className="flex items-center gap-4">
              <a
                href="#"
                className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-orange-500 transition-colors cursor-pointer"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-orange-500 transition-colors cursor-pointer"
              >
                <i className="ri-twitter-x-line text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-orange-500 transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-orange-500 transition-colors cursor-pointer"
              >
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-sm text-blue-200 hover:text-orange-400 transition-colors cursor-pointer"
                >
                  About Us
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-sm text-blue-200 hover:text-orange-400 transition-colors cursor-pointer"
                >
                  Our Services
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('mission')}
                  className="text-sm text-blue-200 hover:text-orange-400 transition-colors cursor-pointer"
                >
                  Mission & Vision
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('agent')}
                  className="text-sm text-blue-200 hover:text-orange-400 transition-colors cursor-pointer"
                >
                  Become an Agent
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-sm text-blue-200 hover:text-orange-400 transition-colors cursor-pointer"
                >
                  Contact Us
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6">Services</h4>
            <ul className="space-y-3">
              <li className="text-sm text-blue-200">AIRTEL SIM Services</li>
              <li className="text-sm text-blue-200">CPaaS Solutions</li>
              <li className="text-sm text-blue-200">SIM Registration</li>
              <li className="text-sm text-blue-200">Business Registration</li>
              <li className="text-sm text-blue-200">Fintech Services</li>
              <li className="text-sm text-blue-200">IT Support</li>
              <li className="text-sm text-blue-200">Digital Marketing</li>
              <li className="text-sm text-blue-200">Skills Training</li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6">Contact Info</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <i className="ri-phone-line text-orange-400 mt-1"></i>
                <div className="text-sm text-blue-200">
                  <p>08164095400</p>
                  <p>07010111298</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-mail-line text-orange-400 mt-1"></i>
                <p className="text-sm text-blue-200">info@thinkpacktech.com.ng</p>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-orange-400 mt-1"></i>
                <p className="text-sm text-blue-200">
                  Sabuwar Hanya Tudun Wada, Gusau, Zamfara State, Nigeria
                </p>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-blue-700 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-sm text-blue-200">
              © 2025 Thinkpack Technologies. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-sm text-blue-200 hover:text-orange-400 transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="text-sm text-blue-200 hover:text-orange-400 transition-colors">
                Terms of Service
              </a>
              <a
                href="https://yusufias-portfolio.vercel.app/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-blue-200 hover:text-orange-400 transition-colors"
              >
                Developed by Yusufia Dev
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}